<template>
  <div class="sliding-task">
    <div class="task-steps">
      <!-- 현재 진행중인 li에 active 클라스 추가 -->
      <li :class="[isActive(troubleTicketInfo.troubleStatus, 1), 'step-processing']" style="margin-right: 205px">처리중</li>
      <li :class="[isActive(troubleTicketInfo.troubleStatus, 2), 'step-complete']">처리 완료</li>
    </div>
    <div class="title-bar title-h4 mr-t30">장애티켓 정보</div>
    <div class="list form-list sys-font">
      <el-form ref="form" label-width="120px" label-position="left">
        <el-form-item label="티켓번호">{{ troubleTicketInfo.troubleTicketGroupId }}</el-form-item>
        <el-form-item label="발행자">{{ troubleTicketInfo.writerId }}</el-form-item>
        <el-form-item label="발행일시">{{ getDateFormatter(null, null, troubleTicketInfo.writeDatetime) }}</el-form-item>
        <el-form-item label="긴급도">{{ troubleTicketInfo.troubleUrgencyName }}</el-form-item>
        <el-form-item label="영향도">{{ troubleTicketInfo.troubleImpactName }}</el-form-item>
      </el-form>
    </div>
    <!-- 대상 이벤트 정보 -->
    <div class="title-bar title-h4 mr-t30">대상 이벤트 정보</div>
    <el-table-wrapper ref="eventTable" class="form-list" :column-default="columnDefault" :data="eventList" :columns="targetEventColumn" :pagination="false" highlight-current-row>
      <template slot-scope="scope" slot="eventlevel-slot">
        <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId" />
      </template>
      <template slot-scope="scope" slot="event-message-slot">
        <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
          동적
        </div>
        {{ scope.row.eventMessage }}
      </template>
    </el-table-wrapper>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';

import TroubleAPI from '@/api/event/trouble-shooting';
import WEventlevelCell from '@/components/table/EventlevelCell';

export default {
  name: 'WTimelineTroubleTicketInfo',
  props: {
    selectedEvent: {
      type: Object,
    },
  },
  components: {
    WEventlevelCell,
  },
  watch: {
    selectedEvent: {
      immediate: true,
      deep: true,
      handler(value) {
        if (!isEmpty(value)) {
          this.loadData();
        }
      },
    },
  },
  data() {
    return {
      columnDefault,
      troubleTicketInfo: {},
      eventList: [],
      targetEventColumn: [
        {
          prop: 'eventlevelId',
          label: '등급',
          width: 80,
          scopedSlot: 'eventlevel-slot',
          className: 'eventlevel',
          columnKey: 'eventlevelId',
        },
        {
          prop: 'objName',
          label: '대상',
          width: 150,
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          scopedSlot: 'event-message-slot',
        },
        {
          prop: 'checkDatetime',
          label: '최초발생시각',
          width: 130,
          formatter: this.getDateFormatter,
        },
      ],
    };
  },
  methods: {
    isActive(value, step) {
      if (!isNil(value)) {
        return this.moveActiveTab(value) === step ? 'active' : '';
      }
      return '';
    },
    moveActiveTab(value) {
      switch (value) {
        case 'R':
          return 1;
        default:
          return 2;
      }
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    loadData() {
      const endDatetime = new Date();
      const startDatetime = new Date();
      startDatetime.setHours(0);
      startDatetime.setMinutes(0);
      startDatetime.setSeconds(0);
      startDatetime.setMilliseconds(0);
      const params = {
        troubleTicketGroupId: this.selectedEvent.timelineTargetId,
        startDatetime,
        endDatetime,
      };
      TroubleAPI.getTroubleShootingDetailInfo(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          if (!isNil(result)) {
            this.troubleTicketInfo = result.troubleShootingInfo;
            this.eventList = result.eventList;
          }
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/performance/root/components/popup/components/TimelineTroubleTicketInfo.vue